import dynamic             from "next/dynamic";
import React, { useState } from "react";

const Presentation       = dynamic ( () => import ( "./presentation" ) );
const PresentationMobile = dynamic ( () => import ( "./presentationMobile" ) );

const component = props => {

	const [ modal, setModal ] = useState ( false );

	const handleToggleModal = () => {
		setModal ( prev => !prev );
	};

	if ( props?.isMobile )
		return (
			<PresentationMobile
				{ ...props }
				handleToggleModal = { handleToggleModal }
				modal             = { modal }
			/>
		);

	return (
		<Presentation
			{ ...props }
		/>
	);
};

export default component;